import { StrictMode } from "react";

import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { createRoot } from "react-dom/client";

import { applyBranding, loadBranding } from "./lib/branding";
import { createQueryClient } from "./lib/query-client";
import { BrandingContext } from "./lib/session";
import { router } from "./router";
import "./styles.css";

/**
 * Branding resolves before the first render (T058), so the app never paints a default palette
 * and then swaps it. An unknown host gets a plain message: there is no "default studio".
 */
const container = document.getElementById("root");
if (!container) {
  throw new Error("No existe el nodo #root: el index.html no es el que corresponde.");
}
const root = createRoot(container);

async function start(): Promise<void> {
  const branding = await loadBranding().catch(() => ({
    error: "No pudimos conectar con el servidor. Revisá tu conexión y recargá la página.",
  }));
  if ("error" in branding) {
    root.render(
      <main style={{ fontFamily: "system-ui", padding: 32, maxWidth: 560 }}>
        <h1 style={{ fontSize: 20 }}>{branding.error}</h1>
        <p>Revisá el enlace que usaste para entrar.</p>
      </main>,
    );
    return;
  }
  applyBranding(branding);
  const queryClient = createQueryClient();
  root.render(
    <StrictMode>
      <BrandingContext.Provider value={branding}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </BrandingContext.Provider>
    </StrictMode>,
  );
}

void start();
